import {Img} from "@brutex/web-component-library/ts";
import classNames from "classnames";
import React, {HTMLProps} from "react";

import PlayIcon from "./PlayIcon";
import Spinner from "./Spinner";

interface PlaycardThumbnailProps extends HTMLProps<HTMLDivElement> {
    className?: string,
    src: string,
    isPlaying: boolean,
    isReady: boolean,
}

const PlayerCardThumbnail = ({className, src, isPlaying, isReady, ...rest}: PlaycardThumbnailProps) => {
    return (
        <div className={classNames(className, isPlaying ? 'opacity-0 pointer-events-none' : 'opacity-100')}
            style={{aspectRatio: `${16 / 9}`, transition: 'opacity 500ms ease-in-out'}}
            {...rest}>
            <div className='position-relative w-full h-full'>
                <Img className='w-full h-full'
                    style={{objectFit: 'cover'}}
                    url={src} />

                <div className='icon-test position-absolute text-white'
                    style={{top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                    {!isReady ? (<Spinner />) : <PlayIcon />}
                </div>
            </div>
        </div>
    );
};

export default PlayerCardThumbnail;
